import React, { useEffect, useState } from "react";
import { Crown, Trash2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHead, Panel } from "@/pages/vendor/Shell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Team() {
  const { vendor } = useAuth();
  const isOwner = vendor.user.staff_role === "owner";
  const [d, setD] = useState<any>(null);
  const [f, setF] = useState({ name: "", email: "" });
  const load = () => api.get("/vendor/team").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);

  const invite = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api.post("/vendor/team", f);
      setF({ name: "", email: "" });
      toast.success("Staff added — they can log in with an email code");
      load();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (id: string) => { await api.delete(`/vendor/team/${id}`); load(); };

  return (
    <div>
      <PageHead eyebrow={d ? `${d.members.length} of ${d.seats} seats` : "Team"} title="Team" />
      <div className="grid gap-4 xl:grid-cols-[1.4fr_1fr]">
        <Panel className="divide-y divide-border p-0" data-testid="team-list">
          {d?.members.map((m: any) => (
            <div key={m.id} className="flex items-center gap-3 p-4" data-testid={`team-member-${m.id}`}>
              <div className="grid h-9 w-9 place-items-center rounded-sm bg-emerald-50 font-bold text-emerald-700">{m.name?.[0]?.toUpperCase()}</div>
              <div className="min-w-0 flex-1"><p className="truncate font-medium">{m.name}</p><p className="truncate text-xs text-muted-foreground">{m.email}</p></div>
              <span className="flex items-center gap-1 rounded-sm bg-muted px-2 py-0.5 font-mono text-[10px] uppercase">{m.staff_role === "owner" && <Crown className="h-3 w-3 text-amber-600" />}{m.staff_role}</span>
              {isOwner && m.staff_role !== "owner" && <Button size="icon" variant="ghost" onClick={() => remove(m.id)} data-testid={`team-remove-${m.id}`}><Trash2 className="h-4 w-4" /></Button>}
            </div>
          ))}
        </Panel>
        <Panel>
          <h3 className="mb-1 font-semibold">Add booth staff</h3>
          <p className="mb-4 text-xs text-muted-foreground">Staff share all leads, can update stages, notes, chat and follow-ups. Only owners edit the profile, team and billing.</p>
          {isOwner ? (
            <form onSubmit={invite} className="space-y-3">
              <Input required placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="team-name-input" />
              <Input required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="team-email-input" />
              <Button type="submit" className="w-full bg-primary text-white hover:bg-primary/90" data-testid="team-invite-button"><UserPlus className="mr-1 h-4 w-4" /> Add staff</Button>
            </form>
          ) : <p className="text-sm text-muted-foreground">Ask your account owner to add staff.</p>}
        </Panel>
      </div>
    </div>
  );
}
